import { render, staticRenderFns } from "./CabeceraTabla.vue?vue&type=template&id=f1a843ec&"
import script from "./CabeceraTabla.vue?vue&type=script&lang=ts&"
export * from "./CabeceraTabla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('f1a843ec', component.options)
    } else {
      api.reload('f1a843ec', component.options)
    }
    module.hot.accept("./CabeceraTabla.vue?vue&type=template&id=f1a843ec&", function () {
      api.rerender('f1a843ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/reusable/Grid/CabeceraTabla.vue"
export default component.exports